import { h, Fragment, Component } from 'preact';

import style from '../../style/hero.sass';

import HandlebarsHandler from '../util/handlebarsHandler.js';

const getBrandHeroStyleClassNames = (brand) => {
  const classNames = {
    containerStyles: [style.container],
    titleStyles: [style.title],
    subtitleStyles: [style.subtitle],
    blurbStyles: [style.blurb]
  };
  if(brand === 'ruud'){
    classNames.containerStyles.push(style.containerRuud);
    classNames.titleStyles.push(style.titleRuud);
    classNames.subtitleStyles.push(style.subtitleRuud);
    classNames.blurbStyles.push(style.blurbRuud);
  }
  if(brand === 'friedrich'){
    classNames.containerStyles.push(style.containerFriedrich);
    classNames.titleStyles.push(style.titleFriedrich);
  }
  return classNames;
}

const Spacer = ({brand}) => {
  if(brand === 'friedrich'){
    return null;
  }
  return (<Fragment>&nbsp;&nbsp;</Fragment>);
}

export default class Main extends Component {
  render(props, state) {
    if(!this.props.mergedLandingPageData){
      return null;
    }
    const classNames = getBrandHeroStyleClassNames(props.brand);
    const handlebarsHandler = new HandlebarsHandler();
    const titleHtml = handlebarsHandler.renderToHtml(
      'mainContentTitleTemplate',
      props.mergedLandingPageData.mainContentTitleTemplate,
      props.mergedLandingPageData
    );
    const subtitleHtml = handlebarsHandler.renderToHtml(
      'mainContentSubtitleTemplate',
      props.mergedLandingPageData.mainContentSubtitleTemplate,
      props.mergedLandingPageData
    );
    const blurbHtml = handlebarsHandler.renderToHtml(
      'mainContentBlurb',
      props.mergedLandingPageData.mainContentBlurb,
      props.mergedLandingPageData
    );
    return (
      <div className={classNames.containerStyles.join(' ')}>
        <div className={style.brandInfoContainer}>
          <p className={classNames.titleStyles.join(' ')}>
            <span dangerouslySetInnerHTML={{__html: titleHtml}}></span>
            <Spacer brand={props.brand} />
            <span dangerouslySetInnerHTML={{__html: subtitleHtml}}></span>
          </p>
          <p className={classNames.blurbStyles.join(' ')} dangerouslySetInnerHTML={{__html: blurbHtml}}></p>
        </div>
      </div>
    );
  }
}